<template>
  <div class="page-infomaion-detail" :class="{'mobile': _isMobile}">
    <div class="infomaion-detail-wrap " :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="1"></cmpBanner>

      <div class="g-wrap">
        <div class="g-content">
          <cmpDetail :detailData="detailData"></cmpDetail>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/information/detail.scss'
export default {
  data() {
    return {
      pageType: this.$route.query.pageType || '1',
      detailId: this.$route.query.id,
      detailData: {}
    }
  },
  methods: {
    getDetailData() {
      this.dataList = []

      this.listLoading = true
      this.$http
        .get('/webapi/information/detail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.data
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
  },
  created() {
    this.getDetailData()
  }
}
</script>

<style lang="scss" scoped>
.infomaion-detail-wrap {
  
}
</style>


